import { render, staticRenderFns } from "./CoreModal.vue?vue&type=template&id=e2b27642&scoped=true&"
import script from "./CoreModal.vue?vue&type=script&lang=js&"
export * from "./CoreModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b27642",
  null
  
)

export default component.exports